var MediaQueryKeys={global:['media']};export{MediaQueryKeys};